// import React, { useState } from 'react';
// import { useNavigate, useLocation } from "react-router-dom";
// import LOGO from '../../assets/images/logo.png'
// import CLOSE from '../../assets/images/close.png'
// import HANDBURGER from '../../assets/images/burger.png'

// function Header({scrollToSection,overviewRef,amenitiesRef,configRef,floorPlanRef}) {
//     const navigate = useNavigate();
//     const location = useLocation();
//     const [isMenuOpen, setIsMenuOpen] = useState()
//     const toggleMenu = () => {
//         setIsMenuOpen(!isMenuOpen); // Toggle the menu state
//     };

//     // Checking which page is active
//     const isHomePage = location.pathname === '/';
//     const isContactPage = location.pathname === '/Contact';
//     const isServices = location.pathname === '/Service';
//     const isFlashTattoo = location.pathname === '/Flash_tattoos';
//     const isOurWork = location.pathname === '/Ourwork';
//     const isOurBlogs = location.pathname === '/Blog';
//     const isAbout = location.pathname === '/About';

//     return (
//         <div className='md:pt-3 max-w-1440 w-full mx-auto xl:px-[5vh] md:px-[2vh] px-[3vh] flex items-center justify-center pr-6'>
//             <div className="overflow-hidden w-full">
//                 <nav className="flex flex-wrap items-center justify-between w-full text-lg text-gray-700">
//                     <div className="flex items-center justify-between w-full lg:w-auto">
//                         <a onClick={() => navigate("/")} className="flex justify-center w-full md:w-auto">
//                             <img src={LOGO} alt='logo' className="lg:w-[92px] md:w-[48px] w-[48.16px] lg:h-[100px] md:h-[48px] h-[36.12px] md:mt-0 mt-4" />
//                         </a>
//                         <img src={HANDBURGER} alt='toggle' className="h-[30px] w-[30px] cursor-pointer lg:hidden block" onClick={toggleMenu} />
//                     </div>

//                     <div className={`w-full lg:flex lg:items-center lg:w-auto ${isMenuOpen ? "block bg-white pl-4 z-50" : "hidden"}`} id="menu">
//                         <div className='flex justify-end cursor-pointer' onClick={()=> setIsMenuOpen(false)}>
//                         <img src={CLOSE} alt='close' className='lg:hidden block w-[17.349px] h-[17.121px]'/>
//                         </div>
//                         <ul className=" text-base text-gray-700 lg:flex lg:justify-between justify-center items-center xl:gap-4">
//                             <li className='cursor-pointer' onClick={() => scrollToSection(overviewRef)}>
//                                 <a className={`no-underline lg:text-[16px] md:text-[15px] font-normal text-[12px] md:p-4 py-2 block ${isHomePage ? 'text-[#2D3436]' : 'text-[#1A4C6D]'} hover:text-[#1A4C6D]`}>Over view</a>
//                             </li>
//                             <li className='cursor-pointer' onClick={() => scrollToSection(amenitiesRef)}>
//                                 <a className={`no-underline lg:text-[16px] md:text-[15px] font-normal text-[12px] md:p-4 py-2 block ${isHomePage ? 'text-[#2D3436]' : 'text-[#1A4C6D]'} hover:text-[#1A4C6D]`}>Project Amentias</a>
//                             </li>
//                             <li className='cursor-pointer' onClick={() => scrollToSection(configRef)}>
//                                 <a className={`no-underline lg:text-[16px] md:text-[15px] font-normal text-[12px] md:p-4 py-2 block ${isHomePage ? 'text-[#2D3436]' : 'text-[#1A4C6D]'} hover:text-[#1A4C6D]`}>Project Configuration</a>
//                             </li>
//                             <li className='cursor-pointer' onClick={() => scrollToSection(floorPlanRef)}>
//                                 <a className={`no-underline lg:text-[16px] md:text-[15px] font-normal text-[12px] md:p-4 py-2 block ${isHomePage ? 'text-[#2D3436]' : 'text-[#1A4C6D]'} hover:text-[#1A4C6D]`}>Project Floor Plan</a>
//                             </li>
//                             <li>
//                                 <div >
//                                     <button className={`block lg:text-[18px] italic  rounded-[6px] md:text-[14px] text-[11px] bg-[#1A4C6D]  px-[20px] py-[12px] ${isContactPage ? 'text-gradient border-[#4FF8A7] text-[#4FF8A7]' : 'text-white border-white'}`}>
//                                         Get in Touch
//                                     </button>
//                                 </div>
//                             </li>
//                         </ul>
//                     </div>
//                 </nav>
//             </div>
//         </div>
//     );
// }

// export default Header;

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import LOGO from '../../assets/images/logo.png'
import CLOSE from '../../assets/images/close.png'
import HANDBURGER from '../../assets/images/burger.png'
const Header = ({ scrollToSection, overviewRef, amenitiesRef, configRef, floorPlanRef, contactform }) => {
    const [isScrolled, setIsScrolled] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState()
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen); // Toggle the menu state
    };

    const isHomePage = location.pathname === '/';
    const isContactPage = location.pathname === '/Contact';

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div className={` max-w-1440 w-full mx-auto xl:px-[5vh] md:px-[2vh] px-[3vh] flex items-center justify-center pr-6 transition-all duration-300 py-2 ${isScrolled ? "" : ""
            }`}>
            <div className="overflow-hidden w-full">
                <nav className="flex flex-wrap items-center justify-between w-full text-lg text-gray-700">
                    <div className="flex items-center justify-between w-full lg:w-auto">
                        <a onClick={() => navigate("/")} className="flex lg:justify-center justify-start items-center w-full md:w-auto">
                            <img src={LOGO} alt="logo" className="lg:w-[92px] md:w-[48px] w-[48.16px] lg:h-[100px] md:h-[48px] h-[36.12px]" />
                        </a>
                        <img src={HANDBURGER} alt="toggle" className="h-[30px] w-[30px] cursor-pointer lg:hidden block" onClick={toggleMenu} />
                    </div>

                    <div className={`w-full lg:flex lg:items-center lg:w-auto ${isMenuOpen ? "block bg-white pl-4 z-50" : "hidden"}`} id="menu">
                        <div className="flex justify-end cursor-pointer" onClick={() => setIsMenuOpen(false)}>
                            <img src={CLOSE} alt="close" className="lg:hidden block w-[17.349px] h-[17.121px]" />
                        </div>
                        <ul className="text-base text-gray-700 lg:flex lg:justify-between justify-center items-center xl:gap-4">
                            <li className="cursor-pointer" onClick={() => scrollToSection(overviewRef)}>
                                <a className={`no-underline lg:text-[20px] md:text-[15px] font-bold text-[12px] md:p-4  block ${isHomePage ? "text-[#2D3436]" : "text-[#1A4C6D]"} hover:text-[#1A4C6D]`}>Over view</a>
                            </li>
                            <li className="cursor-pointer" onClick={() => scrollToSection(amenitiesRef)}>
                                <a className={`no-underline lg:text-[20px] md:text-[15px] font-bold text-[12px] md:p-4 block ${isHomePage ? "text-[#2D3436]" : "text-[#1A4C6D]"} hover:text-[#1A4C6D]`}>Project Amenities</a>
                            </li>
                            <li className="cursor-pointer" onClick={() => scrollToSection(configRef)}>
                                <a className={`no-underline lg:text-[20px] md:text-[15px] font-bold text-[12px] md:p-4  block ${isHomePage ? "text-[#2D3436]" : "text-[#1A4C6D]"} hover:text-[#1A4C6D]`}>Project Configuration</a>
                            </li>
                            <li className="cursor-pointer" onClick={() => scrollToSection(floorPlanRef)}>
                                <a className={`no-underline lg:text-[20px] md:text-[15px] font-bold text-[12px] md:p-4  block ${isHomePage ? "text-[#2D3436]" : "text-[#1A4C6D]"} hover:text-[#1A4C6D]`}>Project Floor Plan</a>
                            </li>
                            <li>
                                <div>
                                    <button onClick={() => scrollToSection(contactform)} className={`block lg:text-[18px] italic rounded-[6px] md:text-[14px] text-[11px] bg-[#1A4C6D] px-[20px] py-[12px] ${isContactPage ? "text-gradient border-[#4FF8A7] text-[#4FF8A7]" : "text-white border-white"}`}>
                                        Get in Touch
                                    </button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
        </div>
    );
};

export default Header;
